// q-backtop
class QBackTop extends HTMLElement {
  constructor() {
    super();
    this.init()
  };
  init () {
    let oBtn = this.querySelector(".q-backtop")
    oBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    })

    window.addEventListener("scroll", () => {
      let t = document.documentElement.scrollTop
      if (t > 500) {
        oBtn.style.display='block'
      } else {
        oBtn.style.display='none'
      }
    })
  };

}
if (!customElements.get('q-backtop')) {
  customElements.define('q-backtop', QBackTop);
}

class QArticle extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init()
    }, 1000)
    this.calcTopByRelatedBlog()
  };
  init () {
    async function copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        alert('Replicated')
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
    let oBtn = this.querySelectorAll(".qmap-code")
    let oText = this.querySelectorAll(".qmap-code-text")
    if (oBtn) {
      oBtn.forEach((item,i) => {
        item.onclick = function () {
          let text = oText[i].innerText
          copyTextToClipboard(text)
        }
      })
    }
    
  }
  calcTopByRelatedBlog () {
    let itemDom = this.querySelector('.t4s-article-related');
    let oSticky = this.querySelector(".qmar-sticky")
    function checkScroll() {
      var visibleBottom = window.scrollY + document.documentElement.clientHeight;
      var centerY = itemDom.offsetTop
      var show = centerY < visibleBottom;    
      if (show) {
        oSticky.setAttribute("show", "1")
      }else{
        oSticky.setAttribute("show", "")
      }
    }
    if (itemDom && oSticky) {
      window.addEventListener('scroll', checkScroll);
    }
  }
}
if (!customElements.get('q-article')) {
  customElements.define('q-article', QArticle);
}


// faqs
class QFAQS extends HTMLElement {
  constructor() {
    super();
    this.init()
  };
  init () {
    let oItems = this.querySelectorAll(".qfaq-items")
    let oTabs = this.querySelectorAll(".qfaq-question")
    let oContents = this.querySelectorAll(".qfaq-content-wrap")
    let oContent1s = this.querySelectorAll(".qfaq-content-item")
    oTabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        let height = oContent1s[i].offsetHeight
        if (!oContents[i].offsetHeight) {
          oContents[i].style.height = height + 'px'
          oItems[i].setAttribute("show", 1)
        } else {
          oContents[i].style.height = '0px'
          oItems[i].setAttribute("show", '')
        }
      })
    })

    window.addEventListener("resize", () => {
      oContent1s.forEach((oContent1, i) => {
        let height = oContent1s[i].offsetHeight
        if (oContents[i].offsetHeight) {
          oContents[i].style.height = height + 'px'
        }
      })

    })
  }
}
if (!customElements.get('q-faqs')) {
  customElements.define('q-faqs', QFAQS);
}

// q-collection-product-params
class qCollectionProductParams extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let sectionId = this.getAttribute("section-id")
    let className = `.swiper-${sectionId}`
    let barClassName = `.bar-${sectionId}`
    const swiper = new Swiper(className, {
      loop: false,
      spaceBetween: 15,
      slidesPerView: 2,
      breakpoints: {
        750: {
          spaceBetween: 0,
          slidesPerView: 4
        }
      },
      scrollbar: {
        el: barClassName,
        hide: true,
      },
      freeMode: false
    });
  }
}
if (!customElements.get('q-collection-product-params')) {
  customElements.define('q-collection-product-params', qCollectionProductParams);
}

// q-main-collection
class qMainCollection extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init()
    },1000)
  }
  init () {
    let oPanels = this.querySelectorAll(".qmc-panel")
    let oBtns = this.querySelectorAll(".qmc-facet-header")
    let oProduct = this.querySelector(".t4s-product-wrapper")
    let oWrap = this.querySelector(".qmc-list-maxheight")
    oBtns.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        if (oPanels[i].getAttribute("show") === "1") {
          oPanels[i].setAttribute("show", "")
        } else {
          oPanels[i].setAttribute("show", "1")
        }
      })
    })
    let pHeight = 0
    let rows = 0
    function changeParama () {
      let innerWidth = window.innerWidth
      if (innerWidth > 750) {
        pHeight = oProduct.offsetHeight + 20
        rows = 3
      } else {
        pHeight = oProduct.offsetHeight + 10
        rows = 5
      }
      oWrap.style.maxHeight = pHeight * rows + 'px'
    }
    window.addEventListener("resize", () => {
      changeParama()
    })
    changeParama()
    let oMore = this.querySelector(".qmc-learnmore")
    let oMaxHeight = this.querySelector(".qmc-list-maxheight")
    if (oMore) {
      oMore.addEventListener("click",() => {
        oMaxHeight.setAttribute('show', "1")
        oMore.style.display = 'none'
      })
    }
  }
}
if (!customElements.get('q-main-collection')) {
  customElements.define('q-main-collection', qMainCollection);
}
// q-facets
class QFacets extends HTMLElement {
  constructor() {
    super();
    // setTimeout(() => {
      this.init()
    // },1000)
  }
  init () {
    let oPanels = this.querySelectorAll(".qmc-panel")
    let oBtns = this.querySelectorAll(".qmc-facet-header")
    let oReset = this.querySelector(".qmc-reset")
    
    oBtns.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        if (oPanels[i].getAttribute("show") === "1") {
          oPanels[i].setAttribute("show", "")
        } else {
          oPanels[i].setAttribute("show", "1")
        }
      })
    })
    if (oReset) {
      oReset.addEventListener("click", () => {
        let oReset1 = document.querySelector(".t4s-active-filters__clear")
        let oReset2 = document.querySelector(".t4s-active-filters__remove-filter")
        if (oReset1) {
          oReset1.click()
        } else if (oReset2) {
          oReset2.click()
        }
      })
    }


  }
}
if (!customElements.get('q-facets')) {
  customElements.define('q-facets', QFacets);
}
// q-small-article
class qSmallArticle extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init()
    },1000)
  }
  init () {
    let oWrap = this.querySelector(".qsa-content-wrap")
    let oContent = this.querySelector(".qsa-content")
    let oLearnMore = this.querySelector(".qsa-learnmore")
    let oBtn = this.querySelector(".qsa-learnmore>div")

    let wrapHeight = oWrap.offsetHeight
    let contentHeight = oContent.offsetHeight
    if (wrapHeight < contentHeight) {
      oLearnMore.style.display = 'flex'
    }
    if (oBtn) {
      oBtn.addEventListener("click",() => {
        oLearnMore.style.display = 'none'
        oWrap.style.height = "auto"
      })
    }
  }
}
if (!customElements.get('q-small-article')) {
  customElements.define('q-small-article', qSmallArticle);
}